export default __webpack_public_path__ + "static/media/icon_warning.d0b5d728.svg";